import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 6,
  class: "kn-truncated"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")
  const _component_Menu = _resolveComponent("Menu")
  const _component_DataTable = _resolveComponent("DataTable")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_component_DataTable, {
    class: "p-datatable-sm kn-table  kn-height-full",
    value: _ctx.rows,
    responsiveLayout: "scroll",
    onRowReorder: _ctx.onRowReorder,
    onDrop: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onDrop($event))),
    onDragover: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
    onDragenter: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Column, {
        rowReorder: true,
        style: _ctx.QBESimpleTableDescriptor.style.firstColumn
      }, null, 8, ["style"]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.QBESimpleTableDescriptor.columns, (column) => {
        return (_openBlock(), _createBlock(_component_Column, {
          key: column.header,
          field: column.field,
          style: column.style,
          sortable: true
        }, {
          header: _withCtx(() => [
            _withDirectives(_createVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.$t(column.header)), 1)
            ], 512), [
              [
                _directive_tooltip,
                _ctx.getHeaderTooltip(column),
                void 0,
                { top: true }
              ]
            ])
          ]),
          body: _withCtx((slotProps) => [
            (column.field === 'alias')
              ? (_openBlock(), _createBlock(_component_InputText, {
                  key: 0,
                  class: "kn-material-input p-inputtext-sm qbe-simple-table-input",
                  modelValue: slotProps.data[slotProps.column.props.field],
                  "onUpdate:modelValue": ($event: any) => (slotProps.data[slotProps.column.props.field] = $event),
                  onChange: ($event: any) => (_ctx.$emit('fieldAliasChanged', slotProps.data))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
              : (column.field === 'group')
                ? (_openBlock(), _createBlock(_component_Checkbox, {
                    key: 1,
                    modelValue: slotProps.data[slotProps.column.props.field],
                    "onUpdate:modelValue": ($event: any) => (slotProps.data[slotProps.column.props.field] = $event),
                    binary: true,
                    onChange: ($event: any) => (_ctx.onGroupingChanged(slotProps.data))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
                : (column.field === 'order')
                  ? (_openBlock(), _createBlock(_component_Dropdown, {
                      key: 2,
                      class: "kn-material-input",
                      modelValue: slotProps.data[slotProps.column.props.field],
                      "onUpdate:modelValue": ($event: any) => (slotProps.data[slotProps.column.props.field] = $event),
                      options: _ctx.QBESimpleTableDescriptor.orderingOptions
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                  : (column.field === 'funct')
                    ? (_openBlock(), _createBlock(_component_Dropdown, {
                        key: 3,
                        class: "kn-material-input",
                        modelValue: slotProps.data[slotProps.column.props.field],
                        "onUpdate:modelValue": ($event: any) => (slotProps.data[slotProps.column.props.field] = $event),
                        options: _ctx.getAttributeOptions(slotProps.data),
                        disabled: slotProps.data['group']
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disabled"]))
                    : (column.field === 'visible')
                      ? (_openBlock(), _createBlock(_component_Checkbox, {
                          key: 4,
                          class: "p-ml-3",
                          modelValue: slotProps.data[slotProps.column.props.field],
                          "onUpdate:modelValue": ($event: any) => (slotProps.data[slotProps.column.props.field] = $event),
                          binary: true,
                          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('columnVisibilityChanged')))
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                      : (column.field === 'inUse')
                        ? (_openBlock(), _createBlock(_component_Checkbox, {
                            key: 5,
                            class: "p-ml-2",
                            modelValue: slotProps.data[slotProps.column.props.field],
                            "onUpdate:modelValue": ($event: any) => (slotProps.data[slotProps.column.props.field] = $event),
                            binary: true
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                        : _withDirectives((_openBlock(), _createBlock("span", _hoisted_1, [
                            _createTextVNode(_toDisplayString(slotProps.data[slotProps.column.props.field]), 1)
                          ], 512)), [
                            [
                              _directive_tooltip,
                              slotProps.data[slotProps.column.props.field],
                              void 0,
                              { top: true }
                            ]
                          ])
          ]),
          _: 2
        }, 1032, ["field", "style"]))
      }), 128)),
      _createVNode(_component_Column, {
        style: _ctx.QBESimpleTableDescriptor.style.lastColumn
      }, {
        body: _withCtx((slotProps) => [
          _createVNode(_component_Button, {
            icon: "fas fa-ellipsis-v",
            class: "p-button-link",
            onClick: ($event: any) => (_ctx.toggle($event, slotProps.data, slotProps.index)),
            "data-test": "menu-toggle"
          }, null, 8, ["onClick"]),
          _createVNode(_component_Menu, {
            ref: "menu",
            model: _ctx.menuItems,
            popup: true
          }, null, 8, ["model"])
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }, 8, ["value", "onRowReorder"]))
}